<template>
  <div id="ligacao">
    <cliente :cliente_id="cliente_id" class="mb-3" />
    <div class="row">
      <div class="col-md-12">
        <div class="card card-default">
          <div v-chat-scroll class="card-body msg_container_base" id="chat">
            <div class="forum" v-for="item in historico" :key="item.id">
              <div class="row msg_container base_receive">
                <div class="col-md-12 col-xs-12">
                  <div class="messages msg_receive">
                    <small
                      ><strong
                        v-if="item.colaborador && item.colaborador.name"
                        >{{ item.colaborador.name }}</strong
                      ></small
                    >
                    <small v-if="item.start_task != 1 && item.end_task != 1">
                      <strong>comentou:</strong>
                    </small>
                    <small v-if="item.start_task && table_name == 'certidoes'">
                      <strong>adicionou pendência:</strong>
                    </small>
                    <small
                      v-if="
                        item.start_task == null &&
                        item.end_task == 1 &&
                        table_name == 'certidoes'
                      "
                    >
                      <strong>removeu a pendência:</strong>
                    </small>
                    <p>
                      {{ item.notification_message }}
                    </p>

                    <time>{{
                      moment(item.created_at).format("DD/MM/YYYY HH:mm")
                    }}</time>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <form
              id="form_chat"
              @submit.prevent="submit()"
              class="ajax_off"
              method="post"
              action=""
            >
              <b-button
                :variant="`${
                  !remover_pendecia ? 'outline-success' : 'outline-primary'
                } mb-2`"
                v-if="table_name == 'certidoes' && tem_pendencia"
                type="button"
                @click="remover_pendecia = !remover_pendecia"
              >
                <span v-if="!remover_pendecia">Remover pendência</span
                ><span v-else>Manter pendência</span></b-button
              >
              <b-button
                :variant="`${
                  pendencia ? 'outline-danger' : 'outline-secondary'
                } mb-2`"
                v-if="table_name == 'certidoes' && !tem_pendencia"
                @click="pendencia = !pendencia"
                type="button"
              >
                <span v-if="!pendencia">Inserir pendência</span
                ><span v-else>Cancelar pendência</span></b-button
              >

              <div class="form-group">
                <textarea
                  id="btn-input-note"
                  name="descricao"
                  class="form-control input-sm chat_input"
                  autocomplete="off"
                  v-model="new_message.message"
                  autofocus=""
                  :placeholder="placeholder"
                  required=""
                ></textarea>
              </div>
              <div class="form-group">
                <b-button
                  type="submit"
                  variant="outline-secondary"
                  class="float-right"
                  id="btn-chat"
                >
                  <i class="fa fa-save"></i> Salvar
                </b-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      placeholder: "Escreva sua mensagem aqui...",
      pendencia: false,
      remover_pendecia: false,
      cliente: {},
      historico: [],
      new_message: {
        message: "",
        pendencia: null,
      },
    };
  },
  watch: {
    remover_pendecia(newValue) {
      this.placeholder = !newValue
        ? "Escreva sua mensagem aqui..."
        : "Justifique a remoção da pendência...";
    },
    pendencia(newValue) {
      this.placeholder = !newValue
        ? "Escreva sua mensagem aqui..."
        : "Escreva aqui a pendência...";
    },
  },
  computed: {
    ...mapState("historico", [
      "cliente_id",
      "table_name",
      "table_id",
      "tem_pendencia",
    ]),
  },
  created() {
    this.getHistorico();
  },
  methods: {
    ...mapMutations("historico", ["setPendencia"]),
     ...mapMutations("datatable", ["setReload"]),
    async getHistorico() {
      const result = await this.$api.get(
        `historico/${this.table_name}/${this.table_id}`
      );
      this.historico = result.data;
    },
    async submit() {
      this.new_message.table_name = this.table_name;
      this.new_message.table_id = this.table_id;

      if (this.pendencia) {
        $("#countPendencia").html(parseInt($("#countPendencia").html()) + 1);
        this.new_message.start_task = true;

        this.setPendencia(1);
      } else if (this.remover_pendecia) {
        if (parseInt($("#countPendencia").html() > 0)) {
            $("#countPendencia").html(parseInt($("#countPendencia").html()) - 1);        
        } else {
          $("#countPendencia").html(0);
        }

        this.new_message.end_task = true;
        this.setPendencia(0);
      }

      const result = await this.$api.post("historico", this.new_message);
      if (result.data.ok) {
        this.new_message.message = "";
        this.new_message.reschedule = null;
        this.getHistorico();

        this.setReload();
      }
   
    },
  },
};
</script>